module.exports = __webpack_public_path__ + "img/coldway-awards-fr.c73814e2.png";